import { monolithHttpClient } from 'src/editor/api/http-clients/monolith-http-client'

export default function saveUserColors(colors) {
  return monolithHttpClient.post('user/colors/v2', {
    value: colors,
  })
}
